module.exports = __webpack_public_path__ + "img/star_D.0aaa6aac.svg";